module.exports = __webpack_public_path__ + "static/images/pick-up-2.2P5Jiw5.svg";